import { actionTypes } from "./storeTypes";

export const init_global = {
  auth: undefined,
  controlPopupMenu: {
    menuItems: {},
    showPopup: false,
    selected: {},
    label: "",
  },
  debug: false,
  dimensions: { vh: 0, navHeight: 0, vw: 0 },
  defaultTicker: "SPY",
  incognito: false,
  loading: true,
  scrollTop: 0,
  showNavBar: false,
  tooltip: {
    active: false,
    position: { x: 200, y: 200 },
    content: {},
    stroke: "",
  },
  titlepopup: {
    active: false,
    label: "",
    title: "",
  },
};

export function global_reducer(state, action) {
  switch (action.type) {
    case actionTypes.SET_AUTH: {
      return {
        ...state,
        auth: action.payload,
      };
    }
    case actionTypes.SET_CONTROL_POPUP_MENU: {
      return {
        ...state,
        controlPopupMenu: {
          ...state.controlPopupMenu,
          menuItems: {
            ...state.controlPopupMenu.menuItems,
            ...(action.payload.menuItems || {}),
          },
          selected: {
            ...state.controlPopupMenu.selected,
            ...(action.payload.selected || {}),
          },
          type: {
            ...state.controlPopupMenu.type,
            ...(action.payload.type || {}),
          },
          showPopup: action.payload.showPopup !== undefined 
            ? action.payload.showPopup 
            : state.controlPopupMenu.showPopup,
          label: action.payload.label !== undefined 
            ? action.payload.label 
            : state.controlPopupMenu.label,
        },
      };
    }
    case actionTypes.SET_DIMENSIONS: {
      return {
        ...state,
        dimensions: action.payload,
      };
    }
    case actionTypes.SET_DEFAULT_TICKER: {
      return {
        ...state,
        defaultTicker: action.payload,
      };
    }
    case actionTypes.SET_INGOGNITO: {
      return {
        ...state,
        incognito: action.payload,
      };
    }
    case actionTypes.SET_LOADING: {
      return {
        ...state,
        loading: action.payload,
      };
    }
    case actionTypes.SET_SCROLLTOP: {
      return {
        ...state,
        scrollTop: action.payload,
      };
    }
    case actionTypes.SET_SHOWNAVBAR: {
      return {
        ...state,
        showNavBar: action.payload,
      };
    }
    case actionTypes.SET_TITLEPOPUP: {
      return {
        ...state,
        titlepopup: action.payload,
      };
    }
    case actionTypes.SET_TOOLTIP: {
      return {
        ...state,
        tooltip: action.payload,
      };
    }
    default:
      return state;
  }
}
